import { useEffect } from 'react';

export const useChatbotVisibilityControl = ({ isHidden }: { isHidden: boolean }) => {
  useEffect(() => {
    const zE = window.zE;
    if (!zE) return;
    zE('messenger:set', 'zIndex', isHidden ? -1 : 99999);

    return () => zE('messenger:set', 'zIndex', 99999);
  }, [isHidden]);
};
